import $i18n from '@/lang/index';
// 包裹类型
export const ParcelType = [
  {
    label: $i18n.t('placeOrder.zhifa'), // 直单
    value: 1
  },
  {
    label: $i18n.t('orderCenterCont.hedan'), // 合单
    value: 2
  },
  {
    label: $i18n.t('GlobalSetObj.big01'), // 大件
    value: 4
  },
  {
    label: $i18n.t('mdfeTranslate.multipleItemsPerOrderSingleNfe'), // 一单多件(单NFe)
    value: 5
  },
  {
    label: $i18n.t('mdfeTranslate.multipleItemsPerOrderMultiNfe'), // 一单多件(多NFe)
    value: 6
  },
  {
    label: $i18n.t('orderCenterCont.other'), // 其他
    value: 3
  }
];
